import { Head } from '@inertiajs/react';
import Musicbox from '@/components/musicbox';
import Layout from '@/layouts/layout';

export default function Music({albums, singles}) {
    return (
        <Layout>
            <Head title="Albums" />
            <Musicbox albums={albums.data} singles={singles.data} />
        </Layout>
    );
}
